const flags = {
  AI: '🇦🇮',
  AD: '🇦🇩',
  AW: '🇦🇼',
  TF: '🇹🇫',
  AG: '🇦🇬',
  BI: '🇧🇮',
  BH: '🇧🇭',
  AS: '🇦🇸',
  AQ: '🇦🇶',
  AX: '🇦🇽',
  WF: '🇼🇫',
  AE: '🇦🇪',
  BZ: '🇧🇿',
  BL: '🇧🇱',
  CI: '🇨🇮',
  BY: '🇧🇾',
  BM: '🇧🇲',
  BV: '🇧🇻',
  AR: '🇦🇷',
  AT: '🇦🇹',
  CF: '🇨🇫',
  CC: '🇨🇨',
  VA: '🇻🇦',
  AU: '🇦🇺',
  BD: '🇧🇩',
  BE: '🇧🇪',
  VI: '🇻🇮',
  IE: '🇮🇪',
  PR: '🇵🇷',
  PS: '🇵🇸',
  KZ: '🇰🇿',
  KG: '🇰🇬',
  TJ: '🇹🇯',
  TM: '🇹🇲',
  UZ: '🇺🇿',
  GE: '🇬🇪',
  MN: '🇲🇳',
  LK: '🇱🇰',
  NP: '🇳🇵',
  MV: '🇲🇻',
  BG: '🇧🇬',
  BO: '🇧🇴',
  BR: '🇧🇷',
  CA: '🇨🇦',
  CH: '🇨🇭',
  CL: '🇨🇱',
  CN: '🇨🇳',
  CO: '🇨🇴',
  CR: '🇨🇷',
  CU: '🇨🇺',
  CY: '🇨🇾',
  CZ: '🇨🇿',
  DE: '🇩🇪',
  DK: '🇩🇰',
  DO: '🇩🇴',
  DZ: '🇩🇿',
  EC: '🇪🇨',
  EG: '🇪🇬',
  EE: '🇪🇪',
  ES: '🇪🇸',
  FI: '🇫🇮',
  FR: '🇫🇷',
  NR: '🇳🇷',
  IO: '🇮🇴',
  GB: '🇬🇧',
  GH: '🇬🇭',
  GR: '🇬🇷',
  HK: '🇭🇰',
  HR: '🇭🇷',
  VG: '🇻🇬',
  HU: '🇭🇺',
  ID: '🇮🇩',
  IL: '🇮🇱',
  IN: '🇮🇳',
  IR: '🇮🇷',
  IS: '🇮🇸',
  IT: '🇮🇹',
  JP: '🇯🇵',
  KE: '🇰🇪',
  KR: '🇰🇷',
  LT: '🇱🇹',
  LU: '🇱🇺',
  LV: '🇱🇻',
  MA: '🇲🇦',
  MT: '🇲🇹',
  MX: '🇲🇽',
  MY: '🇲🇾',
  NG: '🇳🇬',
  NL: '🇳🇱',
  NO: '🇳🇴',
  NZ: '🇳🇿',
  PE: '🇵🇪',
  PH: '🇵🇭',
  PK: '🇵🇰',
  PL: '🇵🇱',
  PT: '🇵🇹',
  QA: '🇶🇦',
  RO: '🇷🇴',
  RS: '🇷🇸',
  RU: '🇷🇺',
  SA: '🇸🇦',
  SD: '🇸🇩',
  SE: '🇸🇪',
  SG: '🇸🇬',
  SI: '🇸🇮',
  SK: '🇸🇰',
  SN: '🇸🇳',
  TH: '🇹🇭',
  TN: '🇹🇳',
  TR: '🇹🇷',
  TW: '🇹🇼',
  UA: '🇺🇦',
  UK: '🇬🇧',
  UY: '🇺🇾',
  VN: '🇻🇳',
  ZA: '🇿🇦',
  ZM: '🇿🇲',
  ZW: '🇿🇼',
  AF: '🇦🇫',
  AL: '🇦🇱',
  AM: '🇦🇲',
  AO: '🇦🇴',
  AZ: '🇦🇿',
  BA: '🇧🇦',
  BB: '🇧🇧',
  BF: '🇧🇫',
  BJ: '🇧🇯',
  BN: '🇧🇳',
  BS: '🇧🇸',
  BT: '🇧🇹',
  BW: '🇧🇼',
  KH: '🇰🇭',
  CM: '🇨🇲',
  CV: '🇨🇻',
  DJ: '🇩🇯',
  GA: '🇬🇦',
  GM: '🇬🇲',
  GQ: '🇬🇶',
  GW: '🇬🇼',
  HN: '🇭🇳',
  JM: '🇯🇲',
  KI: '🇰🇮',
  KM: '🇰🇲',
  LS: '🇱🇸',
  MG: '🇲🇬',
  MW: '🇲🇼',
  ML: '🇲🇱',
  MR: '🇲🇷',
  MU: '🇲🇺',
  MZ: '🇲🇿',
  NA: '🇳🇦',
  NE: '🇳🇪',
  OM: '🇴🇲',
  PA: '🇵🇦',
  PG: '🇵🇬',
  PY: '🇵🇾',
  RW: '🇷🇼',
  SC: '🇸🇨',
  SL: '🇸🇱',
  ST: '🇸🇹',
  SY: '🇸🇾',
  TG: '🇹🇬',
  TO: '🇹🇴',
  TT: '🇹🇹',
  TZ: '🇹🇿',
  UG: '🇺🇬',
  VU: '🇻🇺',
  WS: '🇼🇸',
  YE: '🇾🇪',
  US: '🇺🇸',
  VE: '🇻🇪',
  CD: '🇨🇩',
  CG: '🇨🇬',
  CK: '🇨🇰',
  CW: '🇨🇼',
  CX: '🇨🇽',
  KY: '🇰🇾',
  DM: '🇩🇲',
  ER: '🇪🇷',
  EH: '🇪🇭',
  ET: '🇪🇹',
  FJ: '🇫🇯',
  FK: '🇫🇰',
  FO: '🇫🇴',
  FM: '🇫🇲',
  GG: '🇬🇬',
  GI: '🇬🇮',
  GN: '🇬🇳',
  GP: '🇬🇵',
  GD: '🇬🇩',
  GL: '🇬🇱',
  GT: '🇬🇹',
  GF: '🇬🇫',
  GU: '🇬🇺',
  GY: '🇬🇾',
  HM: '🇭🇲',
  HT: '🇭🇹',
  IM: '🇮🇲',
  IQ: '🇮🇶',
  JE: '🇯🇪',
  JO: '🇯🇴',
  KN: '🇰🇳',
  XK: '🇽🇰',
  KW: '🇰🇼',
  LA: '🇱🇦',
  LB: '🇱🇧',
  LR: '🇱🇷',
  LY: '🇱🇾',
  LC: '🇱🇨',
  LI: '🇱🇮',
  MO: '🇲🇴',
  MF: '🇲🇫',
  MC: '🇲🇨',
  MD: '🇲🇩',
  MH: '🇲🇭',
  MK: '🇲🇰',
  MM: '🇲🇲',
  ME: '🇲🇪',
  MP: '🇲🇵',
  MS: '🇲🇸',
  MQ: '🇲🇶',
  YT: '🇾🇹',
  NC: '🇳🇨',
  NF: '🇳🇫',
  NI: '🇳🇮',
  NU: '🇳🇺',
  PN: '🇵🇳',
  PW: '🇵🇼',
  KP: '🇰🇵',
  PF: '🇵🇫',
  RE: '🇷🇪',
  GS: '🇬🇸',
  SJ: '🇸🇯',
  SB: '🇸🇧',
  SV: '🇸🇻',
  SM: '🇸🇲',
  SO: '🇸🇴',
  PM: '🇵🇲',
  SS: '🇸🇸',
  SR: '🇸🇷',
  SZ: '🇸🇿',
  SX: '🇸🇽',
  TC: '🇹🇨',
  TD: '🇹🇩',
  TK: '🇹🇰',
  TL: '🇹🇱',
  TV: '🇹🇻',
  UM: '🇺🇲',
  VC: '🇻🇨',
};

const getCountryFlagByCountryCode = (countryCode: string) => {
  return flags[countryCode];
};

export default getCountryFlagByCountryCode;
